// extracted by mini-css-extract-plugin
export default {"list":"Menu_list__WKkIy","item":"Menu_item__jfaZL","container":"Menu_container__p9Ypa","admin":"Menu_admin__Sb21m","faq":"Menu_faq__WSRSL","footer":"Menu_footer__XdnsS"};